const BASE_URL = "https://api.semicolonstudios.com";
const CLIENT_ID = "mweeb_webapp";
const PUBLIC_KEY = "MWEEB_PUB_3d2f9b74c91e4a70";
const SUBMISSION_KEY = "MWEEB_SUB_7c1f3e9a4d2b6f8c0e5a1b7d9f3c6e2a";

async function generateSignature(method, path, timestamp, nonce, body) {
  const canonical = [method, path, timestamp, nonce, body].join("\n");

  const encoder = new TextEncoder();
  const keyData = encoder.encode(SUBMISSION_KEY);
  const messageData = encoder.encode(canonical);

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyData,
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );

  const signatureBuffer = await crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    messageData,
  );
  const hashArray = Array.from(new Uint8Array(signatureBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

async function semicolonRequest(path, body = {}) {
  const method = "POST";
  const timestamp = Math.floor(Date.now() / 1000).toString();
  const nonce = crypto.randomUUID().replace(/-/g, "");
  const rawBody = JSON.stringify(body);

  const signature = await generateSignature(
    method,
    path,
    timestamp,
    nonce,
    rawBody,
  );

  const response = await fetch(`${BASE_URL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      "X-Client-Id": CLIENT_ID,
      "X-Public-Key": PUBLIC_KEY,
      "X-Timestamp": timestamp,
      "X-Nonce": nonce,
      "X-Signature": signature,
    },
    body: rawBody,
  });

  return response.json();
}

export async function ping() {
  return semicolonRequest("/ping", {});
}

export async function submitEmployee(employeeData) {
  return semicolonRequest("/submit", employeeData);
}
